import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config'
import type { TailwindConfig } from 'tailwindcss/tailwind-config'

const fullConfig:TailwindConfig = resolveConfig(tailwindConfig)

const screens = fullConfig.theme.screens ?
  Object.fromEntries(Object.entries(fullConfig.theme.screens).map((item) => {
    item[1] = +item[1].match(/\d+/)[0]
  return item
})) : {} // delete 'px'


interface Brp {
  xxs: boolean,
  xs: boolean,
  sm: boolean,
  md: boolean,
  lg: boolean,
  xl: boolean,
  smAndDown: boolean,
  mdAndDown: boolean,
  lgAndDown: boolean,
  xlAndDown: boolean,
  xxlAndDown: boolean
  desktop: boolean,
  tablet: boolean,
  mobile: boolean,
  mobileSmall: boolean,
  width: number,
  height: number
}

interface Screens {
  xxs: number,
  xs: number,
  sm: number,
  md: number,
  lg: number,
  xl: number,
  desktop: number,
  tablet: number
}

class breakpointInstance {

  private resizeTimeout: number
  public scrollBarWidth: number
  public breakpoints: Brp
  public screens: Screens

  constructor(options = {scrollBarWidth: 16}) {
    this.resizeTimeout = 0
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.screens = screens
    this.scrollBarWidth = options.scrollBarWidth
    this.breakpoints = {
      xxs: false,
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
      mobile: false,
      mobileSmall: false,
      desktop: false,
      tablet: false,
      smAndDown: false,
      mdAndDown: false,
      lgAndDown: false,
      xlAndDown: false,
      xxlAndDown: false,
      width: 0,
      height: 0
    }
  }

  install(Vue) {
    this.update()
    window.addEventListener(
      'resize',
      this.onResize.bind(this),
      { passive: true }
    )
    Vue.prototype.$breakpoints = Vue.observable(this.breakpoints)
  }
  update(): void {
    const height = this.getClientHeight()
    const width = this.getClientWidth()
    this.breakpoints.xs = width < this.screens.xs
    this.breakpoints.sm = this.screens.xs < width && width < this.screens.sm
    this.breakpoints.md = width < (this.screens.md - this.scrollBarWidth)
      && !(this.breakpoints.sm || this.breakpoints.xs)
    this.breakpoints.lg = width < (this.screens.lg - this.scrollBarWidth)
      && !(this.breakpoints.md || this.breakpoints.sm || this.breakpoints.xs)
    this.breakpoints.xl = width < (this.screens.xl - this.scrollBarWidth)
      && !(this.breakpoints.lg || this.breakpoints.md || this.breakpoints.sm || this.breakpoints.xs)

    this.breakpoints.smAndDown = width < this.screens.sm
    this.breakpoints.mdAndDown = width < this.screens.md
    this.breakpoints.lgAndDown = width < this.screens.lg
    this.breakpoints.xlAndDown = width < this.screens.xl

    this.breakpoints.desktop = width > this.screens.desktop
    this.breakpoints.tablet = width > this.screens.xs && !this.breakpoints.desktop
    this.breakpoints.mobile = width < this.screens.xs
    this.breakpoints.mobileSmall = width < this.screens.xxs

    this.breakpoints.width = width
    this.breakpoints.height = height

  }
  onResize(): void {
    clearTimeout(this.resizeTimeout)
    this.resizeTimeout = window.setTimeout(this.update.bind(this), 200)
  }
  getClientWidth(): number {
    return Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    )
  }

  getClientHeight(): number {
    return Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    )
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $breakpoints: Brp
  }
}

export default new breakpointInstance()
